import { render, staticRenderFns } from "./probationAssignmentComplete.vue?vue&type=template&id=496e340e&scoped=true&"
import script from "./probationAssignmentComplete.vue?vue&type=script&lang=js&"
export * from "./probationAssignmentComplete.vue?vue&type=script&lang=js&"
import style0 from "./probationAssignmentComplete.vue?vue&type=style&index=0&id=496e340e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e340e",
  null
  
)

export default component.exports